module.exports = __webpack_public_path__ + "img/118.979a956a.png";